/* eslint-disable  no-underscore-dangle */
import _ from 'lodash';

import EntityServiceFactory, { ensureUuid, ENTITY_TYPES } from '../../../services/EntityService';

function getEntityTypeParams(entityType, state) {
    const uuid = state?.uuid;
    switch (entityType) {
        case ENTITY_TYPES.VIRTUAL_MACHINE:
            return {
                server: uuid,
            };
        case ENTITY_TYPES.HYPERVISOR:
            return {
                server: uuid,
                hypervisor: uuid,
                requester: 'hypervisor-detail',
            };
        default:
            return {
                [entityType]: uuid,
            };
    }
}

function entityIsDevice(entityType) {
    switch (entityType) {
        case ENTITY_TYPES.ACCESS_POINT:
        case ENTITY_TYPES.DEVICE:
        case ENTITY_TYPES.HYPERVISOR:
        case ENTITY_TYPES.SERVER:
        case ENTITY_TYPES.VIRTUAL_MACHINE:
        case ENTITY_TYPES.WIRELESS_CONTROLLER:
            return true;
        default:
            return false;
    }
}

function getDefaultSummary(entityType, state, nameProperty) {
    const value = _.get(state, nameProperty);
    return entityIsDevice(entityType) && state?.ipAddress ? `${value} (${state.ipAddress})` : value;
}

export default function getEntityListFilterStateServiceFactory(title, entityType, nameProperty = 'name') {
    return (filterId) => ({
        /*
         * Factory functions
         */
        createWithEncodedState(encodedState, dataService) {
            return EntityServiceFactory(dataService).getEntity(entityType, encodedState);
        },

        createWithDefaultState(dataService) {
            return EntityServiceFactory(dataService)
                .getEntities(entityType, {
                    rowStart: 0,
                    rowLimit: 1,
                })
                .then((entities) => _.first(entities.data));
        },

        createState(encodedFilterState, dataService) {
            const encodedState = encodedFilterState?.[filterId];
            return encodedState
                ? this.createWithEncodedState(encodedState, dataService)
                : this.createWithDefaultState(dataService);
        },

        /*
         * Transformation functions
         */
        parameterize(state) {
            return getEntityTypeParams(entityType, state);
        },

        encode(state) {
            // We may get legacy filter states from saved filters that do not have a `uuid` property.  This
            // ensures the state is normalized to have a `uuid` property before encoding.
            const stateToEncode = ensureUuid(state);
            return stateToEncode?.uuid;
        },

        summarize(state) {
            return {
                title,
                value: getDefaultSummary(entityType, state, nameProperty),
                shortValue: _.get(state, nameProperty),
            };
        },
    });
}
